<template>
  <div class="w-full flex flex-col">
    <div class="m-2 p-4 bg-white rounded shadow space-y-4">
      <div class="flex items-center gap-3">
        <h1 class="text-lg font-medium text-primary flex-grow">Training courses</h1>
        <router-link class="px-4 py-2 bg-primary text-white rounded" to="/Matrices/Courses/new">New course</router-link>
      </div>
      <p class="text-sm text-gray-600" v-if="loaded && !courses.length">No courses yet.</p>
      <ul class="divide-y" v-else>
        <li class="py-3 flex flex-col gap-2 md:flex-row md:items-center" v-for="course in courses" :key="course.ID">
          <div class="flex-grow">
            <p class="font-medium">{{ course.Title }}</p>
            <p class="text-sm text-gray-600">
              {{ course.Status === "published" ? "Published" : "Draft" }}
              <span v-if="course.Difficulty"> · {{ course.Difficulty }}</span>
              <span v-if="course.EstimatedMinutes"> · {{ course.EstimatedMinutes }} min</span>
              <span> · {{ completionCount(course) }} completions</span>
            </p>
          </div>
          <div class="flex gap-2">
            <router-link class="px-3 py-1 border rounded" :to="`/Matrices/Courses/${course.ID}`">Edit</router-link>
            <router-link class="px-3 py-1 bg-primary text-white rounded" v-if="course.Status === 'published'" :to="`/Matrices/Courses/${course.ID}/play`">Start</router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { db } from "../../../db.js";

const store = useStore();
const loaded = ref(false);

const courses = computed(() => Object.entries(store.state["Home/Courses"] || {})
  .map(([key, course]) => ({ ...course, ID: course?.ID || key }))
  .sort((a, b) => String(b?.Date?.Created || "").localeCompare(String(a?.Date?.Created || ""))));

function completionCount(course) {
  return Object.keys(course?.Completions || {}).length;
}

onMounted(async () => {
  await db.watch("Home/Courses", store);
  loaded.value = true;
});
</script>
